import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./typography.module.scss";

function H({level, children, className}) {
  return React.createElement(
    `h${level}`,
    {className: classNames(styles[`h${level}`], className)},
    children
  );
}

H.defaultProps = {
  level: 1
};

H.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  className: PropTypes.string,
  level: PropTypes.number.isRequired
};

export default H;
